module.exports = __webpack_public_path__ + "img/overview@2x.ea508bdb.png";